export const SALES_USERS_READ_ROLES = [
  'owner',
  'admin',
  'sales',
  'purchasing',
  'finance',
  'warehouse',
  'web',
  'stc'
]

export const SALES_USERS_CR_EMAILS = [
  'corry.belleandkate@gmail.com'
]

export const SALES_USERS_CREATE_ROLES = SALES_USERS_READ_ROLES
export const SALES_USERS_UPDATE_ROLES = [ 'product curated', 'owner', 'admin', 'sales', 'warehouse', 'web', 'purchasing', 'finance', 'stc' ]

export const normalizeSalesUsersRole = (value) => value
  ?.toString()
  .trim()
  .toLowerCase()
  .replace(/_/g, ' ')
  .replace(/\s+/g, ' ') || ''

export const salesUsersRoleFor = (user = {}) => (
  normalizeSalesUsersRole(user?.role || user?.access)
)

export const salesUsersEmailFor = (user = {}) => (
  user?.email?.toString().trim().toLowerCase() || ''
)

export const salesUsersHasCrEmailAccess = (user = {}) => (
  SALES_USERS_CR_EMAILS.includes(salesUsersEmailFor(user))
)

export const salesUsersCanRead = (user = {}) => (
  salesUsersRoleFor(user) === 'product curated' ||
  SALES_USERS_READ_ROLES.includes(salesUsersRoleFor(user)) ||
  salesUsersHasCrEmailAccess(user)
)

export const salesUsersCanCreate = (user = {}) => (
  SALES_USERS_CREATE_ROLES.includes(salesUsersRoleFor(user)) ||
  salesUsersHasCrEmailAccess(user)
)

export const salesUsersCanUpdate = (user = {}) => (
  SALES_USERS_UPDATE_ROLES.includes(salesUsersRoleFor(user))
)
